import React from "react";

import { Button } from "@kazoohr/confetti";
import { doNothing } from "@kazoohr/helpers";

import {
  useGetCurrentUserQuery,
  useToggleCurrentUserPlatformAdminMutation,
} from "../../../generated/apiHooks";

export function DevAuthTogglePlatformAdmin() {
  const { data } = useGetCurrentUserQuery({
    onError: doNothing, // Error is handled by the provider
  });
  const [handleToggle, { loading }] = useToggleCurrentUserPlatformAdminMutation(
    {
      defaultToastErrorMessageOrTranslationKey:
        "Failed to toggle platform admin status",
      defaultToastSuccessMessageOrTranslationKey:
        "Platform admin status toggled",
    }
  );

  const currentUser = data?.currentUser;

  // Only show for dev auth users
  if (!currentUser || currentUser.source !== "dev") {
    return null;
  }

  const isOverridden = currentUser.organizationOverridden;

  return (
    <div
      style={{
        position: "absolute",
        right: 0,
        top: isOverridden ? "48px" : "0",
      }}
    >
      <Button
        variant="subtle"
        onClick={handleToggle}
        disabled={loading}
        size="extra_small"
      >
        {currentUser.isPlatformAdmin ? "Disable Admin" : "Enable Admin"}
      </Button>
    </div>
  );
}
